import React, { useCallback, useEffect, useState } from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';

import '../GuestHomePage.css';

import { observer } from 'mobx-react';

import GuestCarouselContent from '../../../components/GuestHomePageComponents/V2Components/GuestCarouselContentV2';
import '@splidejs/splide/dist/css/splide.min.css';
import AnchorStore from '../../../store/AnchorStore';
import { mainCarouselContent } from '../../../components/GuestHomePageComponents/CarouselContentV2';
import BecomeAMember from '../../../assets/GuestHome/become_a_member.jpg';
import BecomeAMemberMob from '../../../assets/GuestHome/become_a_member_mobile.jpg';
import CheckEmailMessage from '../CheckEmailMessage';

import styles from './css/GuestHomePageV2.module.css';
import NewUserSignup from './NewUserSignupV2';
import MeetTheAnchorsV2 from './MeetTheAnchorsV2';
import BlogSection from './BlogSection';
import NewFeatures from './NewFeatures';
import TourVideo from './TourVideo';


function GuestHomePageV2(props) {
  const {
    user,
    activeCampaign,
    allActiveCampaigns,
    location,
  } = props;
  const [shouldShowCheckEmailMessage, setShouldShowCheckEmailMessage] = useState(false);
  const urlParams = new URLSearchParams(location?.search);
  const tourVideoParam = urlParams.get('tour_video');

  useEffect(() => {
    AnchorStore.setAnchorsWithFanzone();
  }, []);

  const dismissCheckEmailMessage = useCallback(() => {
    setShouldShowCheckEmailMessage(false);
  }, [setShouldShowCheckEmailMessage]);

  if (tourVideoParam && tourVideoParam !== '') {
    return <TourVideo tourVideo={tourVideoParam} />;
  }

  if (shouldShowCheckEmailMessage && !user.authenticated) {
    return (
      <CheckEmailMessage dismissMessage={dismissCheckEmailMessage} />
    );
  }

  return (
    <div className={styles.montserrat} id="guest-page">
      <Helmet>
        <title>Home | Naked News</title>
        <meta content={mainCarouselContent.main} name="description" />
      </Helmet>
      <div className="container unblurred-container">
        <div className="main-carousel-home">
          <GuestCarouselContent
            activeCampaign={activeCampaign}
            allActiveCampaigns={allActiveCampaigns}
            user={user}
          />
        </div>
        <NewUserSignup
          setShouldShowCheckEmailMessage={setShouldShowCheckEmailMessage}
          user={user}
        />
        <MeetTheAnchorsV2 />
        <NewFeatures />
        <BlogSection />
      </div>
      <Link className={styles.becomeAMember} to={'/account/purchase'}>
        <img alt="Become a Member" className={styles.becomeAMemberDesktop} src={BecomeAMember} />
        <img alt="Become a Member" className={styles.becomeAMemberMob} src={BecomeAMemberMob} />
      </Link>
    </div>
  );
}

export default observer(GuestHomePageV2);
